export function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h4>Product</h4>
          <ul>
            <li>
              <a href="/#how-it-works">How It Works</a>
            </li>
            <li>
              <a href="/#pricing">Pricing</a>
            </li>
            <li>
              <a href="https://docs.naivana.io/">Documentation</a>
            </li>
            <li>
              <a href="/changelog">Changelog</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Company</h4>
          <ul>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/blog">Blog</a>
            </li>
            <li>
              <a href="mailto:carlton@naivana.co">Contact</a>
            </li>
            <li>
              <a href="/careers">We&apos;re Hiring</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Resources</h4>
          <ul>
            <li>
              <a href="/case-studies">Case Studies</a>
            </li>
            <li>
              <a href="/api-reference">API Reference</a>
            </li>
            <li>
              <a href="https://github.com/naivana/pathfinder-examples">Examples</a>
            </li>
            <li>
              <a href="/status">Status</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li>
              <a href="/privacy">Privacy Policy</a>
            </li>
            <li>
              <a href="/terms">Terms of Service</a>
            </li>
            <li>
              <a href="/security">Security</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 Naivana, Inc. Built with caffeine and Claude Sonnet.</p>
      </div>
    </footer>
  );
}
